import { MedRoundDto } from './Dtos'

export class WardDto {
    id: string;
    name: string; 
    notes: string;
    wardRounds: Array<MedRoundDto>

}


// WEBPACK FOOTER //
// ./ClientApp/dto/WardDto.ts